import type { ReactNode } from "react";

import type { BillingConfigPrice } from "../../types";
import IconTooltip from "../icon-tooltip";

interface PriceDisplayProps {
  price: BillingConfigPrice;
  hideDescription?: boolean;
  single?: boolean;
}

export function PriceDisplay({
  price,
  hideDescription,
  single,
}: PriceDisplayProps): ReactNode {
  return (
    <div className={`flex ${single ? "flex-row gap-2" : "flex-col"}`}>
      <div className="flex items-baseline justify-between">
        <div className="font-heading font-semibold text-r8-2xl break-anywhere text-r8-gray-12">
          {price.price}
        </div>
      </div>

      <div
        className={`${
          hideDescription ? "flex items-center gap-2" : "space-y-1"
        }`}
      >
        <p className="text-r8-sm text-r8-gray-11 group-hover:text-r8-gray-12 transition-colors">
          {price.title}
        </p>
        {price.description ? (
          hideDescription ? (
            <IconTooltip
              size={16}
              weight="regular"
              icon={"Info"}
              tooltipText={price.description}
            />
          ) : (
            <p className="text-r8-xs text-r8-gray-10 group-hover:text-r8-gray-12 transition-colors">
              {price.description}
            </p>
          )
        ) : null}
      </div>
    </div>
  );
}
